<template>
    <header-default class="header--basic">
        <slot />
    </header-default>
</template>

<script>
import HeaderDefault from "@/sets/styles/headers/header-default.vue";

export default {
    props: {},
    components: {
        HeaderDefault,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
